export default {"src":"/_next/static/media/iPhone 13.12dbdffb.svg","height":587,"width":531,"blurWidth":0,"blurHeight":0};